import type { ImportIssuesResult, IssueCsvMapping } from '@qlk/shared';

import { DongLoiCsv, FormNhapCsv as FormChung, type TruongCsv } from '../../../ui/index.js';

/**
 * Nhập sự cố từ CSV xuất tay từ YouTube Studio.
 * Khung form dùng chung ở `apps/web/src/ui/FormNhapCsv.tsx` (gộp ở bước 12.2);
 * ở đây chỉ còn bảng cột và câu chữ riêng của module 09.
 */

export interface FormNhapCsvProps {
  dangGui: boolean;
  loi?: string | null;
  ketQua?: ImportIssuesResult | null;
  onGui: (input: { csv: string; mapping: IssueCsvMapping }) => void;
  onHuy: () => void;
}

const TRUONG: TruongCsv<keyof IssueCsvMapping & string>[] = [
  { khoa: 'channelHandle', nhan: 'Kênh (handle hoặc tên)', macDinh: 'channel' },
  { khoa: 'type', nhan: 'Loại sự cố', macDinh: 'type' },
  { khoa: 'videoTitle', nhan: 'Tên video', macDinh: 'video' },
  { khoa: 'videoRef', nhan: 'Mã video', macDinh: 'video_id' },
  { khoa: 'claimant', nhan: 'Bên khiếu nại', macDinh: 'claimant' },
  { khoa: 'dueDate', nhan: 'Hạn phản hồi', macDinh: 'due_date' },
];

export function FormNhapCsv({ dangGui, loi, ketQua, onGui, onHuy }: FormNhapCsvProps) {
  return (
    <FormChung
      truong={TRUONG}
      dangGui={dangGui}
      {...(loi === undefined ? {} : { loi })}
      nhanGui="Nhập sự cố"
      nhanFile="File CSV xuất từ YouTube Studio"
      onGui={({ csv, mapping }) => {
        onGui({ csv, mapping });
      }}
      onHuy={onHuy}
      ketQua={
        ketQua ? (
          <div className="rounded-[10px] bg-ok-nen p-4 text-co-ban text-ok-chu">
            Đã thêm {ketQua.created} sự cố, bỏ qua {ketQua.skipped} dòng trùng với sự cố đang mở.
            <DongLoiCsv loi={ketQua.errors} />
          </div>
        ) : null
      }
    />
  );
}
